




























import {
  defineComponent,
  ref,
  useContext,
  watch
} from '@nuxtjs/composition-api';
import type { TranslateResult } from 'vue-i18n/types';

import { useUiState } from '~/composables';
import VaimoButton from '~/diptyqueTheme/components/atoms/VaimoButton.vue';
import AccountSidebarTab from '~/diptyqueTheme/components/organisms/sidebar/parts/AccountSidebarTab.vue';
import VaimoSidebar from '~/diptyqueTheme/components/organisms/VaimoSidebar.vue';
import { validateFraction } from '~/diptyqueTheme/helpers/priceFormatter';

interface Tab {
  name: string | TranslateResult;
  id: number;
  componentName: string;
}

export default defineComponent({
  name: 'VaimoAccountSidebar',
  components: {
    VaimoButton,
    VaimoSidebar,
    AccountSidebarTab
  },
  props: {
    visible: Boolean
  },
  emits: ['close'],
  setup(_, { emit }) {
    const { sidebarActionType } = useUiState();
    const { app } = useContext();
    const activeTabIndex = ref(null);
    const activeComponent = ref('AccountSidebarTab');
    const TABS = {
      ACCOUNT: 1
    };
    const tabs = ref<Tab[]>([
      {
        name: app.i18n.t('Account'),
        id: TABS.ACCOUNT,
        componentName: 'AccountSidebarTab'
      }
    ]);

    const close = () => {
      emit('close');
      activeTabIndex.value = 0;
      activeComponent.value = 'AccountSidebarTab';
    };

    const onTabClick = (tab: Tab) => {
      activeComponent.value = tab.componentName;
    };

    watch(
      () => sidebarActionType.value,
      (newValue) => {
        if (newValue === 'account') {
          activeComponent.value = 'AccountSidebarTab';
          activeTabIndex.value = 0;
        } else {
          activeComponent.value = null;
          activeTabIndex.value = null;
        }
      },
      { immediate: true }
    );

    return {
      tabs,
      onTabClick,
      sidebarActionType,
      close,
      activeTabIndex,
      activeComponent,
      validateFraction
    };
  }
});
